module.exports = __webpack_public_path__ + "img/信创认证.fc7f9b6c.png";